import { useState, useEffect } from 'react';
import { DateInputOld2 as DateInput2 } from '../../../../common/Input';

//icons
import CloseIcon from '@mui/icons-material/Close';

export function EducationAddForm({
  isOpen,
  onClose,
  employeePersonalInformationId,
  addEmployeesEducation
}) {
  const [level, setLevel] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [address, setAddress] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [course, setCourse] = useState('');
  const [honors, setHonors] = useState('');

  const handleSubmit = () => {
    if (!level
    ) {
      alert("Required to fill up atleast 'Level' data");
      return; // Exit early if fields are empty
    }

    addEmployeesEducation(employeePersonalInformationId, level, schoolName, address, dateFrom, dateTo, course, honors);
    // Clear form fields
    setLevel('');
    setSchoolName('');
    setAddress('');
    setDateFrom('');
    setDateTo('');
    setCourse('');
    setHonors('');
  };

  const handleClose = () => {
    onClose();
    setLevel('');
    setSchoolName('');
    setAddress('');
    setDateFrom('');
    setDateTo('');
    setCourse('');
    setHonors('');
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div id="education-form" className="add-employees-form">
              <div className="popUp-header row">
                <div className='popUp-title'><h3 style={{ color: "#668fca" }}>Add Education Background</h3></div>
                <div className='popUp-close'><CloseIcon onClick={() => handleClose()} /></div>
              </div>
              <div className="popUp-body">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Level</div>
                  <div className="info-item-input"><input id="AddEmployee-Level" placeholder="Level" onChange={(e) => setLevel(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">School Name</div>
                  <div className="info-item-input"><input id="AddEmployee-SchoolName" placeholder="School Name" onChange={(e) => setSchoolName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Address</div>
                  <div className="info-item-input"><input id="AddEmployee-Address" placeholder="Address" onChange={(e) => setAddress(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateInput2 id="Education-DateFrom" value={dateFrom} onChange={(value) => setDateFrom(value)} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateInput2 id="Education-DateTo" value={dateTo} onChange={(value) => setDateTo(value)} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Course</div>
                  <div className="info-item-input"><input id="AddEmployee-Course" placeholder="Course" onChange={(e) => setCourse(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Honors</div>
                  <div className="info-item-input"><input id="AddEmployee-Honors" placeholder="Honors" onChange={(e) => setHonors(e.target.value)} /></div>
                </div>
                <div className="educations-tab-footer tab-footer">
                  <div className="buttons row" style={{ justifyContent: "end" }}>
                    <button id="add-education"
                      className="save row"
                      onClick={handleSubmit}>
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}
export function EducationEditForm({
  isOpen,
  onClose,
  editData,
  employeePersonalInformationId,
  addEmployeesEducation
}) {
  const [level, setLevel] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [address, setAddress] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [course, setCourse] = useState('');
  const [honors, setHonors] = useState('');

  const handleSubmit = () => {
    if (!level
    ) {
      alert("Required to fill up atleast 'Level' data");
      return; // Exit early if fields are empty
    }

    addEmployeesEducation(employeePersonalInformationId, level, schoolName, address, dateFrom, dateTo, course, honors);
    // Clear form fields
    setLevel('');
    setSchoolName('');
    setAddress('');
    setDateFrom('');
    setDateTo('');
    setCourse('');
    setHonors('');
  };

  const handleClose = () => {
    onClose();
    setLevel('');
    setSchoolName('');
    setAddress('');
    setDateFrom('');
    setDateTo('');
    setCourse('');
    setHonors('');
  }

  useEffect(() => {
    if (isOpen) {
      setLevel(editData.level);
      setSchoolName(editData.schoolName);
      setAddress(editData.address);
      setDateFrom(editData.dateFrom);
      setDateTo(editData.dateTo);
      setCourse(editData.course);
      setHonors(editData.honors);
    }
  }, [isOpen, editData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div id="education-form" className="add-employees-form">
              <div className="popUp-header row">
                <div className='popUp-title'><h3 style={{ color: "#668fca" }}>Edit Education Background</h3></div>
                <div className='popUp-close'><CloseIcon onClick={() => handleClose()} /></div>
              </div>
              <div className="popUp-body">
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Level</div>
                  <div className="info-item-input"><input id="AddEmployee-Level" value={level} placeholder="Level" onChange={(e) => setLevel(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">School Name</div>
                  <div className="info-item-input"><input id="AddEmployee-SchoolName" value={schoolName} placeholder="School Name" onChange={(e) => setSchoolName(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Address</div>
                  <div className="info-item-input"><input id="AddEmployee-Address" value={address} placeholder="Address" onChange={(e) => setAddress(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date From</div>
                  <div className="info-item-input">
                    <DateInput2 id="Education-DateFrom" value={dateFrom} onChange={(value) => setDateFrom(value)} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Date To</div>
                  <div className="info-item-input">
                    <DateInput2 id="Education-DateTo" value={dateTo} onChange={(value) => setDateTo(value)} />
                  </div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Course</div>
                  <div className="info-item-input"><input id="AddEmployee-Course" value={course} placeholder="Course" onChange={(e) => setCourse(e.target.value)} /></div>
                </div>
                <div className="popUp-item info-item column">
                  <div className="info-item-label">Honors</div>
                  <div className="info-item-input"><input id="AddEmployee-Honors" value={honors} placeholder="Honors" onChange={(e) => setHonors(e.target.value)} /></div>
                </div>
                <div className="educations-tab-footer tab-footer">
                  <div className="buttons row" style={{ justifyContent: "end" }}>
                    <button id="add-education"
                      className="save row"
                      onClick={handleSubmit}>
                      SAVE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}